export default function setFoeError(foeError) {
    return {
        type: 'SET_FOE_ERR',
        payload: foeError
    }
}